/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Container, SlideStayInformed } from './styles';
import Botox from './Botox';
import ClearAligners from './ClearAligners';
import Implants from './Implants';
import Doctors from './Doctors';

import devsigner from '~/assets/tv/devsigner-logo.svg';
import bgNews from '~/assets/tv/bg-news.png';
import qrCodeWhatsapp from '~/assets/tv/qrcode-whatsapp.svg';
import JowlLipo from './JowlLipo';

interface ISlide {
  slide: string;
  slideTime: number;
  beforeTime?: number;
  afterTime?: number;
  bgSlide?: string;
}

const Tv: React.FC = () => {
  const valentinesVideoRef = useRef<HTMLVideoElement>(null);
  const [slideSelected, setSlideSelected] = useState({} as ISlide);
  const [showBefore, setShowBefore] = useState('SlideCoiKidsIntro');
  const [animSlideSelected, setAnimSlideSelected] = useState('');
  const [endAnimSlideSelected, setEndAnimSlideSelected] = useState('');

  const slides = useMemo<ISlide[]>(
    () => [
      { slide: 'ClearAligners', slideTime: 65000 },
      { slide: 'Botox', slideTime: 15000 },
      { slide: 'JowlLipo', slideTime: 7500 },
      { slide: 'Implants', slideTime: 40000 },
      { slide: 'Doctors', slideTime: 30000 },
      { slide: 'SlideStayInformed', slideTime: 15000 },
    ],
    []
  );

  const changeSlide = useCallback(
    (index) => {
      const { slide, slideTime } = slides[index];

      if (slides[index + 1] && slides[index + 1].beforeTime) {
        const nextSlide = slides[index + 1];
        if (nextSlide.beforeTime)
          setTimeout(() => {
            setShowBefore(nextSlide.slide);
            setAnimSlideSelected(nextSlide.slide);
          }, slideTime - nextSlide.beforeTime);
      }

      if (slides[index - 1] && slides[index - 1].afterTime) {
        const prevSlide = slides[index - 1];
        if (prevSlide.afterTime) {
          setEndAnimSlideSelected(prevSlide.slide);
          setSlideSelected(slides[index]);
          setTimeout(() => {
            setShowBefore('');
            setEndAnimSlideSelected('');
          }, prevSlide.afterTime);
        }
      } else {
        setSlideSelected(slides[index]);
      }

      setTimeout(() => {
        setAnimSlideSelected(slide);
        if (index + 1 < slides.length) {
          setTimeout(() => {
            changeSlide(index + 1);
          }, slideTime);
        } else {
          setTimeout(() => {
            changeSlide(0);
          }, slideTime);
        }
      }, 100);
    },
    [slides]
  );

  useEffect(() => {
    if (slideSelected.slide === 'ValentinesVideo') {
      valentinesVideoRef.current?.play();
    }
  }, [slideSelected.slide]);

  useEffect(() => {
    changeSlide(0);
  }, [changeSlide]);

  return (
    <Container className="position-relative">
      <JowlLipo
        show={slideSelected.slide === 'JowlLipo'}
        startAnim={animSlideSelected === 'JowlLipo'}
      />
      <Botox
        show={slideSelected.slide === 'Botox'}
        startAnim={animSlideSelected === 'Botox'}
      />
      <ClearAligners
        show={slideSelected.slide === 'ClearAligners'}
        startAnim={animSlideSelected === 'ClearAligners'}
      />
      <Implants
        show={slideSelected.slide === 'Implants'}
        startAnim={animSlideSelected === 'Implants'}
      />
      <Doctors
        show={slideSelected.slide === 'Doctors'}
        startAnim={animSlideSelected === 'Doctors'}
      />
      <SlideStayInformed
        show={slideSelected.slide === 'SlideStayInformed'}
        startAnim={animSlideSelected === 'SlideStayInformed'}
        endAnim={endAnimSlideSelected === 'SlideStayInformed'}
        bgImage={bgNews}
      >
        <div className="slide-container">
          <p className="title">
            Quer acompanhar todas as novidades e promoções?
          </p>
          <img
            src={qrCodeWhatsapp}
            alt="qrCodeWhatsapp"
            className="qr-whatsapp"
          />
          <p className="content">
            <b>Salve nosso contato</b> e fique por dentro de todas as novidades
          </p>
          <div className="d-flex align-items-center devsigner">
            <p className="mb-0">Desenvolvido por:</p>
            <img src={devsigner} alt="devsigner" />
          </div>
        </div>
      </SlideStayInformed>
    </Container>
  );
};

export default Tv;
